<template>
	<v-dialog
		max-width="700px"
		:value="true"
		no-click-animation
		persistent
		hide-overlay
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		scrollable
	>
		<v-card class="pa-0">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white"> {{ name }} </v-app-bar-title>
				<v-spacer />
			</v-app-bar>
			<v-form ref="form" lazy-validation class="pa-2">
				<h6 class="font-weight-bold text-body-1 mt-4">参照する元データを選択してください。</h6>
				<v-sheet class="table-container mt-4" elevation="0">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="items"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr class="clickable" @click="showDialog($event, item.id)">
								<td>{{ item.name }}</td>
								<td>{{ datetimeFormat(item.created_at) }}</td>
								<td>{{ datetimeFormat(item.updated_at) }}</td>
							</tr></template
						>
					</v-data-table>
					<v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
						<v-list>
							<v-list-item @click="selectData">
								<v-list-item-title>元データとして選択する</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				</v-sheet>
				<!-- <v-row no-gutters class="mt-4" justify="center">
					<v-btn color="secondary" :disabled="!isValid" @click="submitForm"> 登録する </v-btn>
				</v-row> -->
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import PaginationModule from "../../shared/PaginationModule.vue"

export default {
	props: {
		name: {
			type: String || null,
			required: false,
			default: null,
		},
		itemData: {
			type: Array,
			required: true,
			default: () => [],
		},
		pagination: {
			type: Object,
			required: true,
			default: null,
		},
	},
	components: {
		PaginationModule,
	},

	data() {
		return {
			id: this.$route.params.id,
			selectedId: null,
			items: [],
			headers: [
				{ text: "名前", value: "name", width: "200px" },
				{ text: "作成日", value: "created_at", width: "200px" },
				{ text: "最終更新日", value: "updated_at", width: "200px" },
			],
			showMenu: false,
			x: 0,
			y: 0,
		}
	},

	methods: {
		showDialog(e, id) {
			this.selectedId = id
			this.showMenu = false
			this.x = e.clientX
			this.y = e.clientY
			this.$nextTick(() => {
				this.showMenu = true
			})
		},
		selectData() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/excel_templates/${this.id}/models/${this.selectedId}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.$emit("set-data", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			this.$emit("fetch-items", i)
			const element = document.getElementsByClassName("v-dialog v-dialog--active")[0]
			element.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		datetimeFormat(datetime) {
			if (!datetime) return null
			return moment(datetime).format("YYYY/MM/DD HH:mm")
		},
	},

	watch: {
		itemData(newValue, _) {
			this.items = newValue
		},
		deep: true,
	},
}
</script>
